import AuthService from 'aurora-composition/services/authService';
import history from 'aurora-utils/history';
import UserService from 'aurora-composition/services/userService';
import ClevertapReact from 'aurora-utils/CleverTap';
import { addToBrowserStorage } from '../utils';
import * as types from '../constants';

export const loginSuccess = (authData, authMode) => ({
  type: types.LOGIN_SUCCESS,
  payload: {
    credential: authData,
    authMode,
  },
});

export const loginFailure = error => ({
  type: types.LOGIN_FAILURE,
  payload: {
    error,
  },
});

export const loginInitiate = () => dispatch => {
  dispatch({ type: types.LOGIN_INITIATE });
};

export const login = (username, password, authMode) => async dispatch => {
  try {
    dispatch({ type: types.LOGIN_REQUEST });
    // in case of guest login
    if (authMode === 'GuestLogin') {
      if (localStorage.getItem('refresh_token') != null) {
        history.push('/app/home');
      } else {
        const guestAccessToken = await AuthService.guestLogin();
        localStorage.setItem('access_token', guestAccessToken);
        if (!localStorage.getItem('refresh_token')) {
          localStorage.setItem('login_with', authMode);
          localStorage.setItem('otp_pending', 'false');
        }
        localStorage.setItem('login_with', authMode);
        localStorage.setItem('otp_pending', 'false');
        const guestResponse = {};
        guestResponse.access_token = guestAccessToken;
        dispatch(loginSuccess(guestResponse, authMode));

        if (!['/', '/en', '/ar'].includes(history.location.pathname)) history.push('/');
      }
    } else {
      // in case uid,unified,uuaePass
      const guestAccessToken = await AuthService.guestLogin();

      localStorage.setItem('access_token', guestAccessToken);
      // set authmode for profile edit
      localStorage.setItem('login_with', authMode);

      // test mobile number
      let testMobileNumber = localStorage.getItem('testMobileNumber');
      if (!testMobileNumber) {
        testMobileNumber = '0923230117677';
        localStorage.setItem('testMobileNumber', testMobileNumber);
      }
      // bussiness login
      let reqParams = {};
      if (authMode === 'eid') {
        reqParams = {
          emiratesID: username,
        };
      } else if (authMode === 'uaePass') {
        reqParams = {
          authToken: username,
        };
      } else if (authMode === 'email') {
        reqParams = {
          email: username?.email,
          password: username?.password,
        };
      } else {
        reqParams = {
          unifiedNumber: username,
        };
      }
      const res = await AuthService.login(reqParams, authMode);

      localStorage.setItem('user', res?.userName || 'ADGM user');
      localStorage.setItem('otp_pending', 'true');

      res.user = res?.userName || 'ADGM user';
      res.userEmail = username?.email || '';

      dispatch(loginSuccess(res, authMode));
      // if (authMode === 'eid') ClevertapReact?.event('Login', { login_method: 'EID' });
      // else if (authMode === 'uaePass') ClevertapReact?.event('Login', { login_method: 'UAE Pass' });
      // else ClevertapReact?.event('Login', { login_method: 'UID' });

      if (res?.data?.access_token || res?.access_token) {
        addToBrowserStorage(res?.data || res);
      }
      const redirctUrl = localStorage.getItem('redirect_url');

      if (authMode === 'uaePass') {
        if (res?.pinId) {
          localStorage.setItem('otp_pending', 'true');
          history.push({
            pathname: '/auth/otp',
            state: { ...res },
          });
        } else {
          try {
            const userRes = await UserService.fetchProfile();
            // clever tap event

            const params = {
              Site: {
                Name: userRes?.customerNameEn || userRes?.firstNameEn,
                Identity: userRes?.userId,
                Email: userRes?.emailAddress,
                Phone_Nummber: userRes?.mobileNumber,
                Gender: userRes?.gender === 'MALE' ? 'M' : 'F',
                DOB: userRes?.birthDate && new Date(userRes?.birthDate),
                'MSG-email': true,
                'MSG-push': true,
                'MSG-sms': true,
                'MSG-whatsapp': true,
                Login_method: authMode,
                Role: 'Personal Account',
                Nationality: userRes?.nationalityEn,
                Is_super_admin: false,
                Name_ar: userRes?.customerNameAr || userRes?.firstNameAr,
                is_owner: userRes?.isOwner,
                is_tenant: userRes?.isTenant,
                is_pma_representative: userRes?.isPma,
                is_poa_representative: userRes?.isPoa,
                is_bank: userRes?.isBank,
                language: localStorage.getItem('lang').toUpperCase(),
                user_plateform: 'WEB',
              },
            };
            localStorage.setItem('selectedAccount', JSON.stringify(userRes));
            // ClevertapReact.onUserLogin(params);

            localStorage.setItem('UserNameEn', userRes?.customerNameEn);
            localStorage.setItem('UserNameAr', userRes?.customerNameAr);
            localStorage.setItem('firstNameEn', userRes?.customerNameEn);
            localStorage.setItem('firstNameAr', userRes?.customerNameAr);
            localStorage.setItem('UserNameBannerEn', userRes?.customerNameEn);
            localStorage.setItem('UserNameBannerAr', userRes?.customerNameAr);
          } catch (e) {
            localStorage.setItem('UserNameEn', 'dummy user');
            localStorage.setItem('UserNameAr', 'dummy user');
          }
          res.user = localStorage.getItem('UserNameEn') || 'ADGM user';
          dispatch(loginSuccess(res, authMode));
          localStorage.setItem('otp_pending', 'false');
          if (redirctUrl && redirctUrl !== 'undefined') {
            if (redirctUrl.includes('?')) {
              history.push(redirctUrl + '&success');
            } else {
              history.push(redirctUrl + '?success');
            }
          } else {
            history.push('/app/home?success');
          }
        }
      } else {
        history.push({
          pathname: '/auth/otp',
          state: { ...res },
        });
      }
    }
  } catch (e) {
    dispatch(loginFailure(e));
  }
};

export const getMarketDataToken = reportId => async dispatch => {
  try {
    dispatch({ type: types.MARKET_LOGIN_REQUEST });
    const marketDataAccessTokenResponse = await AuthService.getMarketDataToken(reportId);
    // if (marketDataAccessTokenResponse.success) dispatch({ type: types.MARKET_LOGIN_REQUEST_SUCCESS, payload: marketDataAccessTokenResponse.result });
    // else dispatch({ type: types.MARKET_LOGIN_REQUEST_ERROR });
    return marketDataAccessTokenResponse;
  } catch (e) {
    return e;
  }
};

export const getMarketDataToken2 = reportId => async dispatch => {
  try {
    dispatch({ type: types.MARKET_LOGIN_REQUEST });

    const marketDataAccessTokenResponse = await AuthService.getMarketDataToken(reportId);

    dispatch({
      type: types.MARKET_LOGIN_SUCCESS,
      payload: {
        token_market: marketDataAccessTokenResponse?.result,
      },
    });

    // }
  } catch (e) {
    dispatch({
      type: types.MARKET_LOGIN_FAILURE,
      payload: {
        error: e,
      },
    });
  }
};

// eslint-disable-next-line
export const verifyEmail = username => async dispatch => {
  try {
    dispatch({ type: types.VERIFY_EMAIL_REQUEST });
    const res = await AuthService.verifyEmail(username);

    if (res?.email) {
      dispatch({
        type: types.VERIFY_EMAIL_SUCCESS,
        payload: {
          email: res.email,
        },
      });
    }
  } catch (e) {
    dispatch(loginFailure(e));
  }
};
// eslint-disable-next-line
export const verifyLink = email => async dispatch => {
  try {
    dispatch({ type: types.VERIFY_LINK_REQUEST });
    const res = await AuthService.verifyLink(email);

    if (res) {
      dispatch({
        type: types.VERIFY_EMAIL_SUCCESS,
      });
    }
  } catch (e) {
    dispatch(loginFailure(e));
    return e;
  }
};
// eslint-disable-next-line
export const createPassword = formData => async dispatch => {
  try {
    dispatch({ type: types.CREATE_PASSWORD_REQUEST });
    const res = await AuthService.createPassword(formData);

    if (res) {
      dispatch({ type: types.CREATE_PASSWORD_SUCCESS });
    } else {
      dispatch({ type: types.CREATE_PASSWORD_FAILURE });
    }
  } catch (e) {
    dispatch(loginFailure(e));
  }
};

export const forgotPassword = email => async dispatch => {
  try {
    dispatch({ type: types.FORGOT_PASSWORD_REQUEST });
    const res = await AuthService.forgotPassword({ email });

    if (res) {
      dispatch({ type: types.FORGOT_PASSWORD_SUCCESS, payload: { userEmail: email } });
    } else {
      dispatch({ type: types.FORGOT_PASSWORD_FAILURE });
    }
    return res;
  } catch (e) {
    dispatch(loginFailure(e));
    return e;
  }
};

export const resetPassword = body => async dispatch => {
  try {
    dispatch({ type: types.RESET_PASSWORD_REQUEST });
    const res = await AuthService.resetPassword(body);

    res && dispatch({ type: types.RESET_PASSWORD_SUCCESS });
    return res;
  } catch (e) {
    dispatch(loginFailure(e));
    return e;
  }
};

export const backToLogin = () => async dispatch => {
  dispatch({ type: types.BACK_TO_LOGIN });
};
